import React from 'react';
import styles from './formsBrowser.module.scss';
import { useTranslation } from 'react-i18next';
import { FavoriteIcon } from './FavoriteIcon';
import { LocalStorageProps, SelectionProps } from './types/FormTypes';

export const FormDetails = React.memo(
    React.forwardRef<
        HTMLDivElement,
        { selectionProps: SelectionProps; localStorageProps: LocalStorageProps }
    >((props, ref) => {
        const { t } = useTranslation();

        try {
            const {
                selectionProps,
                selectionProps: { formSelected },
                localStorageProps,
            } = props;

            return (
                <div className={styles.formDetailsContainer}>
                    <FavoriteIcon
                        selectionProps={selectionProps}
                        localStorageProps={localStorageProps}
                    />
                    <div ref={ref} className={styles.formTitleContainer}>
                        {formSelected?.Title__c}
                    </div>
                    <div className={styles.formDepartmentContainer}>
                        {`${t('FormsBrowser.DetailViewDepartment')}: ${
                            formSelected?.Department__c
                        }`}
                    </div>
                    <div className={styles.formCategoryContainer}>
                        {`${t('FormsBrowser.DetailViewCategory')}: ${
                            formSelected?.Category__c
                        }`}
                    </div>
                    <div className={styles.formDescriptionContainer}>
                        {formSelected?.Description__c}
                    </div>
                    <div className={styles.buttonContainer}>
                        <a
                            href={formSelected?.URL__c}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles?.button}
                        >
                            {t('FormsBrowser.DetailViewLink')}
                        </a>
                    </div>
                </div>
            );
        } catch {
            return null;
        }
    }),
);
